import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { type RepoPaginationResponse } from '@webapp/infrastructure/interfaces/repositories/RepoPaginationResponse'
import {
  V1User,
  type V1UserConstructor,
} from '@webapp/platform/iam/entities/V1User'
import { v1UserQueries } from '@webapp/platform/iam/query-configs/v1UserQueries'

interface UseActiveUsersWithSlackModelParams {
  limit?: number
  offset?: number
  search?: string
  sort?: string
  enabled?: boolean
}

export const useActiveUsersWithSlackModel = (
  params: UseActiveUsersWithSlackModelParams = {}
) => {
  const { enabled = true, ...queryParams } = params

  const { data, isLoading, isFetching, isError, error } = useQuery<{
    data: V1UserConstructor[]
    pagination: RepoPaginationResponse
    metadata: { offset: number }
  }>({
    ...v1UserQueries.activeUsers(queryParams),
    enabled,
    keepPreviousData: true,
  })

  const users = useMemo(() => {
    return (
      data?.data.map(
        (constructorData: V1UserConstructor) => new V1User(constructorData)
      ) ?? []
    )
  }, [data])

  const pagination = data?.pagination ?? {
    count: 0,
    page: 1,
    pageSize: 10,
    numPages: 0,
  }

  const offset = data?.metadata?.offset ?? 0

  return {
    users,
    pagination,
    offset,
    isLoading,
    isFetching,
    isError,
    error,
  }
}
